import React, { useEffect, useState, useCallback } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { useNavigate } from "react-router-dom";
// import React from "react";

function YourAttendingList() {

  const navigate = useNavigate();
  const DEFAULT_CATEGORY = "AUTOMOTIVE";

  const [currentUserId, setCurrentUserId] = useState(null);

  const [usersPreferedCat, getUserSelectedCategory] = useState("");

  const [events, setEvents] = useState([]);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [calendarView, setCalendarView] = useState(window.innerWidth <= 768 ? "dayGridWeek" : "dayGridMonth");

  const [selectedCategory, setSelectedCategory] = useState(DEFAULT_CATEGORY);
// Handle calendar view switching on window resize
useEffect(() => {
  const handleResize = () => {
    const newView = window.innerWidth <= 768 ? "dayGridWeek" : "dayGridMonth";
    setCalendarView(newView);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

// Get event background image
const getEventBackgroundImage = useCallback((event) => {
  const type = (event.EVENT_TYPE || "other").toLowerCase();
  const imgNUM = event.EVENT_IMAGENUM || "";
  const customImage = event.EVENT_IMAGE || null;

  const imageMap = {
    race: `race${imgNUM}`,
    rally: `rally${imgNUM}`,
    meetup: `meetup${imgNUM}`,
    drag: `drag${imgNUM}`,
    drift: `drift${imgNUM}`,
    trackday: `trackday${imgNUM}`,
    motorbike: `motorbike${imgNUM}`,
    hockey: `hockey${imgNUM}`,
    football: `football${imgNUM}`,
    basketball: `basketball${imgNUM}`,
    swimming: `swimming${imgNUM}`,
    festivals: `festivals${imgNUM}`,
    rock: `rock${imgNUM}`,
    indie: `indie${imgNUM}`,
    jazz: `jazz${imgNUM}`,
    dj: `dj${imgNUM}`,
    drumandbass: `drumandbass${imgNUM}`,
    countryfolk: `countryfolk${imgNUM}`,
    metal: `metal${imgNUM}`,
    pop: `pop${imgNUM}`,
    other: `other${imgNUM}`,
  };

  const presetImg = imgNUM ? imageMap[type] || imageMap.other : null;

  if (customImage) {
    return `/assets/img/uploads/events/${event.EVENT_IMAGE}.png`;
  }
  if (presetImg) {
    return `/assets/img/${type}/${presetImg}-640.png`;
  }
  return null;
}, []);

  useEffect(() => {
    const auth = getAuth();
    return onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUserId(user.uid);
      } else {
        setCurrentUserId(null);
        setEvents([]);
        setCalendarEvents([]);
      }
    });
  }, []);
  
    useEffect(() => {
      if (usersPreferedCat && usersPreferedCat.trim() !== "") {
        setSelectedCategory(usersPreferedCat);
      } else {
        setSelectedCategory(DEFAULT_CATEGORY);
      }
    }, [usersPreferedCat]);
  
  useEffect(() => {
    const auth = getAuth();
    const db = getDatabase();

    let unsubscribeDb = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        const usersRef = ref(db, `USERS/${user.uid}`);

        unsubscribeDb = onValue(usersRef, (snapshot) => {
          const data = snapshot.val();
          // console.log(data);
          if (data && data.USERPREFEREDCATEGORY) {
            getUserSelectedCategory(data.USERPREFEREDCATEGORY);
          }
        });
      } else {
        // user logged out → clean DB listener
        if (unsubscribeDb) {
          unsubscribeDb();
          unsubscribeDb = null;
        }
      }
    });

    return () => {
     
      if (unsubscribeDb) unsubscribeDb();
      unsubscribeAuth();
    };
  }, []);


  useEffect(() => {
    if (!currentUserId) return;

    const db = getDatabase();

    const automotiveEventsRef = ref(
      db,
      `EVENTS/EVENT/${selectedCategory}`
    );

    const attendingRef = ref(
      db,
      `USERS/${currentUserId}/ATTENDING/${selectedCategory}`
    );

    let allEvents = {};
    let attendingList = [];

    const mergeData = () => {
      if (!allEvents || attendingList.length === 0) {
        setEvents([]);
        setCalendarEvents([]);
        return;
      }

      const matched = attendingList
        .map((att) => allEvents[att.eventId])
        .filter(Boolean);

      const formattedList = matched.map((e) => ({
        id: e.eventId,
        name: e.EVENT_NAME,
      }));

      const formattedCalendar = matched
        .filter((e) => e.EVENT_DATE) // Only include events with dates
        .map((e) => {
          const [day, month, year] = e.EVENT_DATE.split("/");
          const bgImage = getEventBackgroundImage(e);
          return {
            id: e.eventId,
            title: e.EVENT_NAME,
            date: `${year}-${month}-${day}`,
            EVENT_PRICEWEEKENDMAX: e.EVENT_PRICEWEEKENDMAX,
            EVENT_PRICEWEEKENDMIN: e.EVENT_PRICEWEEKENDMIN,
            EVENT_PRICEVIPMAX: e.EVENT_PRICEVIPMAX,
            EVENT_PRICEVIPMIN: e.EVENT_PRICEVIPMIN,
            EVENT_PRICETRACKMAX: e.EVENT_PRICETRACKMAX,
            EVENT_PRICETRACKMIN: e.EVENT_PRICETRACKMIN,
            EVENT_PRICE: e.EVENT_PRICE,
            EVENT_PRICEMIN: e.EVENT_PRICEMIN,
            EVENT_SOLDOUT: e.EVENT_SOLDOUT,
            extendedProps: {
              location: e.EVENT_LOCATION,
              description: e.EVENT_DESCRIPTION,
              price: e.EVENT_PRICE,
              postcode: e.EVENT_POSTCODE,
              postedby: e.EVENT_OWNERNAME,
              type: e.EVENT_TYPE,
              eventsite: e.EVENT_SITE,
              slug: e.EVENT_SLUG,
              urlkey: e.EVENT_URLKEY,
              eventlocationmap: e.EVENT_LOCATIONMAP,
              eventendtime: e.EVENT_ENDTIME,
              eventstarttime: e.EVENT_STARTTIME,
              minprice: e.EVENT_MINPRICE,
              backgroundImage: bgImage,
            },
          };
        });

      setEvents(formattedList);
      setCalendarEvents(formattedCalendar);
    };

    const unsub1 = onValue(automotiveEventsRef, (snapshot) => {
      allEvents = snapshot.val() || {};
      mergeData();
    });

    const unsub2 = onValue(attendingRef, (snapshot) => {
      const data = snapshot.val();
      attendingList = data ? Object.values(data) : [];
      mergeData();
    });

    return () => {
      unsub1();
      unsub2();
    };
  }, [currentUserId, selectedCategory, getEventBackgroundImage]);



  


  return (
    <div className="row">

      <div className="filter-section mb-5">
      </div>
 


      <div className="row mb-5 ">
        <div className="col-auto">
        <label className="form-label">Category</label>
            <select
              className="form-select w-auto"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              {usersPreferedCat && (
                <option value={usersPreferedCat}>
                  Preferred ({usersPreferedCat})
                </option>
              )}
              <option value="AUTOMOTIVE">Automotive</option>
              <option value="SPORTS">Sports</option>
              <option value="MUSIC">Music</option>
            </select>
        </div> 
      </div>


      {events.length === 0 ? (
        <p className="text-gray-700">
          You are not attending any events yet.
        </p>
      ) : (
      <> 

       <div className="row mb-3 ">
  
          <div className="col-md-12 col-sm-12">
            <div className="collapsed show mb-3" id="calendarView">
              <FullCalendar
                key={`${selectedCategory}-${calendarEvents.length}`}
                plugins={[dayGridPlugin]}
                initialView={calendarView}
                events={calendarEvents}
                eventClassNames={(event) => `attending-cal-${event.event.extendedProps.type}`}
                eventClick={(info) => {
                  const slug = info.event.extendedProps.slug;
                  const urlkey = info.event.extendedProps.urlkey;
                  if (slug && urlkey) {
                    navigate(`/event/${urlkey}/${slug}`);
                  }
                }}
                eventDidMount={(info) => {
                  const bgImage = info.event.extendedProps.backgroundImage;
                  const eventType = info.event.extendedProps.type;
                  
                  // Color mapping for event type borders
                  const typeColorMap = {
                    'RALLY': '#e4d270', 'RACE': '#79c3e3', 'TRACKDAY': '#FD769A', 'DRAG': '#D0FD98',
                    'MEETUP': '#ad9fec', 'DRIFT': '#98FDB6', 'OTHER': '#FABCB4', 'MOTORBIKE': '#d2dce1',
                    'HOCKEY': '#e4d270', 'FOOTBALL': '#79c3e3', 'BASKETBALL': '#FD769A', 'SWIMMING': '#D0FD98',
                  };
                  
                  const dayCell = info.el.closest('.fc-daygrid-day');
                  
                  if (dayCell) {
                    // Apply background only once (multiple events per day)
                    if (!dayCell.dataset.backgroundApplied) {
                      dayCell.dataset.backgroundApplied = 'true';
                      
                      if (bgImage) {
                        dayCell.style.backgroundImage = `url('${bgImage}')`;
                        dayCell.style.backgroundSize = 'cover';
                        dayCell.style.backgroundPosition = 'center';
                        dayCell.style.backgroundRepeat = 'no-repeat';
                        dayCell.style.backgroundAttachment = 'scroll';
                        dayCell.style.filter = 'brightness(0.90)';
                        dayCell.style.borderRadius = '8px';
                      } else {
                        dayCell.classList.add(`calendar-event-image-${eventType}`);
                        dayCell.style.borderRadius = '8px';
                      }
                    }
                    
                    // Add border and style day number
                    const borderColor = typeColorMap[eventType] || '#999';
                    const isMobile = window.innerWidth <= 768;
                    const borderWidth = isMobile ? '2px' : '3px';
                    dayCell.style.border = `${borderWidth} solid ${borderColor} !important`;
                    dayCell.style.boxSizing = 'border-box';
                    
                    // Style day number badge
                    const dayNumber = dayCell.querySelector('.fc-daygrid-day-number');
                    if (dayNumber) {
                      dayNumber.style.backgroundColor = borderColor;
                      dayNumber.style.color = '#fff';
                      dayNumber.style.fontWeight = 'bold';
                      const padding = isMobile ? '2px 4px' : '4px 8px';
                      dayNumber.style.padding = padding;
                      dayNumber.style.borderRadius = '4px';
                      dayNumber.style.display = 'inline-block';
                      dayNumber.style.fontSize = isMobile ? '0.8rem' : 'inherit';
                    }
                  }
                  
                  // Make event transparent, show day background through it
                  info.el.style.backgroundColor = 'transparent';
                  info.el.style.border = 'none';
                  info.el.style.cursor = 'pointer';
                  
                  // Style event title with responsive font sizes
                  const titleEl = info.el.querySelector('.fc-event-title');
                  if (titleEl) {
                    const isMobile = window.innerWidth <= 768;
                    if (bgImage) {
                      titleEl.style.color = '#fff';
                      titleEl.style.textShadow = '0 0 3px rgba(0,0,0,0.8)';
                    } else {
                      titleEl.style.color = '#000';
                    }
                    titleEl.style.fontWeight = '800';
                    titleEl.style.fontFamily = 'Switzer';
                    titleEl.style.whiteSpace = 'initial';
                    titleEl.style.fontSize = isMobile ? '0.7rem' : 'inherit';
                    titleEl.style.lineHeight = '1.2';
                    titleEl.style.overflow = 'hidden';
                    titleEl.style.textOverflow = 'ellipsis';
                    titleEl.style.display = '-webkit-box';
                    titleEl.style.webkitLineClamp = '2';
                    titleEl.style.webkitBoxOrient = 'vertical';
                  }
                  
                  // Semi-transparent overlay for text readability on images
                  const eventContent = info.el.querySelector('.fc-event-title-container');
                  if (eventContent && bgImage) {
                    const isMobile = window.innerWidth <= 768;
                    eventContent.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                    eventContent.style.padding = isMobile ? '2px 3px' : '4px 6px';
                    eventContent.style.borderRadius = '3px';
                  }
                }}
                headerToolbar={{
                  left: "title",
                  center: "",
                  right: "prev,next",
                }}
              />
            </div>
          </div>

        </div>
      </>
      )}

    </div>
  );
}

export default YourAttendingList;
